export default __webpack_public_path__ + "static/future-cccef1f5053466fc1e6f2b9b1e4bd624.webp";